<template>

  <div>
    <Modal
      :title="$t('actions.sync_rates')"
      :submit="submit"
      :submitting="submitting"
      :submit-label="$t('actions.sync_rates')"
      ref="syncRatesModal"
    >

      <p class="mb-4">{{ $t('misc.sync_rates_explanation') }}</p>

      <o-autocomplete
        :label="$t('titles.product_type')"
        v-model="formState.productType"
        :rules="formRules.productType"
        :items="ProductTypeRegistry.getOptions()"
        required
        autofocus
      />

    </Modal>
  </div>

</template>

<script setup lang="ts">

import { reactive, ref, useTemplateRef } from 'vue'
import { useI18n } from 'vue-i18n'

import type Modal from '../../../Modal.vue'

// validation
import { required } from '../../../../validation'

// misc
// @ts-ignore: Don't complain about missing types
import { closeDialog } from 'vue3-promise-dialog'
import NotificationService from '../../../../services/NotificationService'
import RatesApi from '../../../../services/api-clients/RatesApi'
import ProductTypeRegistry from '../../../../product_types/ProductTypeRegistry'

interface Props {
  locationID: number
}

const props = defineProps<Props>()

const syncRatesModal = useTemplateRef<typeof Modal>('syncRatesModal') // template ref
const { t } = useI18n()

/**
 * Form state and rules
 */

const formState = reactive({
  productType: null,
})

const formRules = {
  productType: [required()],
}

/**
 * Submission
 */

const submitting = ref<boolean>(false)

async function submit() {

  await syncRatesModal.value!.modalForm.validate()

  if (!syncRatesModal.value!.modalForm.isValid) {
    return
  }

  submitting.value = true

  RatesApi.triggerAllRates(props.locationID, formState.productType!)
    .then(() => {
      NotificationService.success(t('alerts.sync_rates_success'))
      closeDialog(null)
    })
    .catch((e) => {
      console.error(e)
      NotificationService.error(e)
    })
    .finally(() => {
      submitting.value = false
    })

}

</script>
